import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ObjetivoVendaService } from '../objetivo-venda-service/objetivo-venda.service';
import { ListaBase } from './../../../../shared/crud/ListaBase';
import { EstruturaGridViewBuilder } from './../../../../shared/gridview/EstruturaGridViewBuilder';

@Component({
  selector: 'app-objetivo-venda-lista',
  templateUrl: '../../template/lista.html',
  styleUrls: ['./objetivo-venda-lista.component.css']
})
export class ObjetivoVendaListaComponent
  extends ListaBase
  implements OnInit {
  visualizarTotalRegistros: boolean;
  exibirBotaoDetalhes: boolean;

  constructor(service: ObjetivoVendaService, toastr: ToastrService, router: Router) {
    super(service, toastr, router);
    this.visualizarTotalRegistros = true;
    this.listagemComPaginacao = true;
    this.quantidadeRegistrosPorPagina = 5;
    this.exibirBotaoDetalhes = true;
  }

  ngOnInit() {
    this.buscar();
    this.estrutura = new EstruturaGridViewBuilder()
      .addColuna("nome_dealer", 'Dealer')
      .addColuna("ano", 'parametros.objetivoVenda.ano')
      .addColuna("mes", 'parametros.objetivoVenda.mes')
      .addColuna("valor", 'parametros.objetivoVenda.quantidade')
      .build();
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.id
      || this.filtros.descricao;
  }
}
